import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';

import {getValueWithVat, getValueWithoutVat} from '../Common/helpers';
import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';
import { API } from '../../ws/constants';

class AddEditProduct extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);
        
        this.state = {
            productId:props.props.match.params.id
            ,openModal:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (props.isAdmin || props.loginData.profile.Products.permission === 1)
            ,somethingWasEdited: false
            ,productData:null
            ,fetchSuppliers:null
            ,loading:false
            ,addEditTitle:"Novo Produto"
            ,name:""
            ,profilePic:""
            ,supplierId:""
            ,priceWithVat:"-.--"
            ,priceWithoutVat:"-.--"
            ,costWithVat:"-.--"
            ,costWithoutVat:"-.--"
            ,internalRef:""
            ,supplierRef:""
            ,weight:0
            ,netWeight:0
            ,milliliters:0
            ,quantity:0
            ,dimensions:""
            ,taxPercentage: props.websiteSettings?.VatValue
            ,barCode:""
            ,description:""
            ,ingredients:""
            ,importantInformation:""
            ,alerts:""
            ,notes:""
            ,isActive:1
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        const { isAdmin, loginData } = this.props;
        const isNew = isNaN(this.state.productId);
        const fetches = [fetch(API + "getsuppliers")];

        if(!isNew)
            fetches.push(fetch(API + "getproducts&getbyid="+this.state.productId));            

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((result) => {
            const newState = {
                fetchSuppliers: result[0].data
            };

            if(!isNew && result[1].shortmsg === "NOK"){
                this.props.props.history.push('/');
                return;
            }else if(!isNew && result[1].shortmsg === "OK"){
                const data = result[1].data;
                newState.name = data.Name;
                newState.profilePic = data.Image
                newState.supplierId = data.SupplierId
                newState.internalRef = data.InternalReference
                newState.supplierRef = data.SupplierReference
                newState.weight = data.Weight
                newState.netWeight = data.NetWeight
                newState.milliliters = data.Milliliters
                newState.quantity = data.Quantity
                newState.dimensions = data.Dimensions
                newState.taxPercentage = data.TaxPercentage
                newState.barCode = data.BarCode
                newState.description = data.Description
                newState.ingredients = data.Ingredients
                newState.importantInformation = data.ImportantInformation
                newState.alerts = data.AlertNotes
                newState.notes = data.Notes
                newState.isActive = data.IsActive
                
                if(isAdmin || loginData.profile.Products.cost){
                    newState.costWithVat = data.CostWithVat
                    newState.costWithoutVat = data.CostWithoutVat
                }
                
                if(isAdmin || loginData.profile.Products.price){
                    newState.priceWithVat = data.PriceWithVat
                    newState.priceWithoutVat = data.PriceWithoutVat
                }
            }

            this.setState(newState);
        });
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    /* END React own Functions */

    /* START Handles */

    handleTitleChange = (e) => {this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });}
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleNumberChange = (e) => {const value=e.target.value>0?e.target.value:0;this.setState({ [e.target.id]: value, somethingWasEdited:true });}

    handleChangePriceWithVAT = (e) => {
        this.setState({ 
            priceWithVat: e.target.value
            , priceWithoutVat: getValueWithoutVat(e.target.value, this.state.taxPercentage)
            , somethingWasEdited:true 
        });
    }

    handleChangePriceWithoutVAT = (e) => {
        this.setState({ 
            priceWithoutVat: e.target.value
            , priceWithVat: getValueWithVat(e.target.value, this.state.taxPercentage)
            , somethingWasEdited:true 
        });
    }

    handleChangeCostWithVAT = (e) => {
        this.setState({ 
            costWithVat: e.target.value
            , costWithoutVat: getValueWithoutVat(e.target.value, this.state.taxPercentage)
            , somethingWasEdited:true 
        });
    }

    handleChangeCostWithoutVAT = (e) => {
        this.setState({ 
            costWithoutVat: e.target.value
            , costWithVat: getValueWithVat(e.target.value, this.state.taxPercentage)
            , somethingWasEdited:true 
        });
    }

    handleChangeTaxPercentage = (e) => {
        this.setState({ taxPercentage: e.target.value, somethingWasEdited:true }, this.updateTaxValues);
    }

    handleUploadImage = (evt) => {
        var tgt = evt.target || window.event.srcElement,
            files = tgt.files;

        // FileReader support
        if (FileReader && files && files.length) {
            var fr = new FileReader();
            fr.onload = () => {
                const fileSize = files[0].size;
                this.setState({ profilePic: fr.result, fileSize, somethingWasEdited:true });

                if(fileSize > 2097152){
                    alert("A imagem é demasiado grande. O Tamanho máximo é 2 MegaByte.");
                }
            }
            fr.readAsDataURL(files[0]);
        }

        // Not supported
        else {
            alert("Este browser não permite upload de imagens. Tente noutro browser.");
        }
    }

    handleSave = (e) => {
        e.preventDefault();
        const fileSize = this.state.fileSize;
        if(!this.state.somethingWasEdited)
            return;

        if(fileSize > 2097152){
            alert("A imagem é demasiado grande. O Tamanho máximo é 2 MegaByte.");
            return;
        }

        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            this.setState({loading:true});

            fetch(API + 'saveproduct', {
                method: 'POST'
                ,headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
                ,body: JSON.stringify({
                    productid:this.state.productId
                    ,name:this.state.name.trim()
                    ,profilepic:this.state.profilePic.trim()
                    ,supplierid:this.state.supplierId.trim()
                    ,pricewithvat:this.state.priceWithVat.trim()
                    ,pricewithoutvat:this.state.priceWithoutVat.trim()
                    ,costwithvat:this.state.costWithVat.trim()
                    ,costwithoutvat:this.state.costWithoutVat.trim()
                    ,internalref:this.state.internalRef.trim()
                    ,supplierref:this.state.supplierRef.trim()
                    ,weight:this.state.weight
                    ,netweight:this.state.netWeight
                    ,milliliters:this.state.milliliters
                    ,quantity:this.state.quantity
                    ,dimensions:this.state.dimensions.trim()
                    ,taxpercentage:this.state.taxPercentage
                    ,barcode:this.state.barCode.trim()
                    ,description:this.state.description.trim()
                    ,ingredients:this.state.ingredients.trim()
                    ,importantinformation:this.state.importantInformation.trim()
                    ,alerts:this.state.alerts.trim()
                    ,notes:this.state.notes.trim()
                    ,isactive:this.state.isActive
                    ,cur_userid:this.props.loginData.Id
                    ,cur_username:this.props.loginData.Name
                })
            })
            .then(response => response.json())
            .then(result => this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false }));
        }
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este produto?")){
            this.setState({loading:true});

            fetch(API + 'deleteproduct&productid=' + this.state.productId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message, openModal: true, loading:false });
            });
        }
    }

    /* END Handles */

    /* START Component Functions */

    updateTaxValues = () => {
        this.setState({ 
            priceWithoutVat: getValueWithoutVat(this.state.priceWithVat, this.state.taxPercentage)
            , costWithoutVat: getValueWithoutVat(this.state.costWithVat, this.state.taxPercentage)
        });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Products');
    }

    /* END Component Functions */

    /* START Renders */

    renderSupplierOptions = (e) => {
        const suppliers = this.state.fetchSuppliers;
        if(suppliers===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha o tipo</MenuItem>];
        for (let i=0,n=suppliers.length;i<n;i++) {
            items.push(<MenuItem value={suppliers[i].Id}
                                 checked={this.state.supplierId === suppliers[i].Id}
                                 className="insetItem"
                                 key={suppliers[i].Id}>{suppliers[i].Name}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;

        const addEditTitle = this.state.productId > 0 && this.state.name ? this.state.name : this.state.addEditTitle
              , optsSuppliers = this.renderSupplierOptions()
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <form id="addEditProductPage" ref="editForm" onSubmit={this.handleSave} className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-clipboard-list"></i> {addEditTitle}
                            {(isAdmin || loginData.profile.Products.isActive) && 
                                <span className="float-right">
                                    <FormControlLabel
                                        label="Ativo"
                                        control={
                                            <Switch
                                                id="isActive"
                                                checked={!!+this.state.isActive}
                                                disabled={!(isAdmin || (loginData.profile.Products.isActive.permission === 1 && editable))}
                                                onChange={this.handleToggle}
                                                color="primary"/>
                                        }/>
                                </span>
                            }
                        </h1>
                    </div>
                </div>
                { (isAdmin || loginData.profile.Suppliers) && 
                    <div className="row">
                        <div className="col-12">
                            <span className="float-right"><i className="fa fa-dolly"></i> <NavLink to={"/Suppliers/"}>Ver Fornecedores</NavLink></span>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-2">
                        <figure className="profilePic bigPic">
                            <input type="file" id="uploadPic" onChange={this.handleUploadImage} disabled={!editable} />
                            <img src={this.state.profilePic !== "" ? this.state.profilePic : "/img/no_image_available_s.png"} alt={this.state.fullName} title={this.state.fullName} />
                        </figure>
                    </div>
                    <div className="col-12 col-sm-6 col-md-10">
                        <div className="row">
                            <div className="col-12 col-md-6 fieldHolder required">
                                <TextField fullWidth
                                        id="name"
                                        value={this.state.name}
                                        onChange={this.handleFieldChange}
                                        label="Nome"
                                        placeholder="Introduza o nome"
                                        disabled={!editable}
                                        data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="fieldHolder required selectField">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="supplierId">Fornecedor</InputLabel>
                                        <Select id="supplierId"
                                                name="supplierId"
                                                value={this.state.supplierId}
                                                onChange={this.handleSelectChange}
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio">
                                        {optsSuppliers}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="fieldHolder moneyHolder">
                                    <TextField fullWidth
                                            id="priceWithVat"
                                            value={this.state.priceWithVat}
                                            onChange={this.handleChangePriceWithVAT}
                                            label="Preço com IVA"
                                            placeholder="Preço com IVA"
                                            disabled={!(isAdmin || (loginData.profile.Products.price && loginData.profile.Products.price.permission === 1 && editable))}/>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="fieldHolder moneyHolder">
                                    <TextField fullWidth
                                            id="priceWithoutVat"
                                            value={this.state.priceWithoutVat}
                                            onChange={this.handleChangePriceWithoutVAT}
                                            label="Preço sem IVA"
                                            placeholder="Preço sem IVA"
                                            disabled={!(isAdmin || (loginData.profile.Products.price && loginData.profile.Products.price.permission === 1 && editable))}/>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="fieldHolder moneyHolder">
                                    <TextField fullWidth
                                            id="costWithVat"
                                            value={this.state.costWithVat}
                                            onChange={this.handleChangeCostWithVAT}
                                            label="Custo com IVA"
                                            placeholder="Custo com IVA"
                                            disabled={!(isAdmin || (loginData.profile.Products.cost && loginData.profile.Products.cost.permission === 1 && editable))}/>
                                </div>
                            </div>
                            <div className="col-12 col-md-3">
                                <div className="fieldHolder moneyHolder">
                                    <TextField fullWidth
                                            id="costWithoutVat"
                                            value={this.state.costWithoutVat}
                                            onChange={this.handleChangeCostWithoutVAT}
                                            label="Custo sem IVA"
                                            placeholder="Custo sem IVA"
                                            disabled={!(isAdmin || (loginData.profile.Products.cost && loginData.profile.Products.cost.permission === 1 && editable))}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-12 col-md-3 fieldHolder gramsHolder">
                                <TextField fullWidth
                                        id="weight"
                                        type="number"
                                        min="1"
                                        value={this.state.weight}
                                        onChange={this.handleFieldChange}
                                        label="Peso"
                                        placeholder="Peso"
                                        disabled={!editable} />
                            </div>
                            <div className="col-12 col-md-3 fieldHolder gramsHolder">
                                <TextField fullWidth
                                        id="netWeight"
                                        type="number"
                                        min="1"
                                        value={this.state.netWeight}
                                        onChange={this.handleFieldChange}
                                        label="Peso Líquido"
                                        placeholder="Peso Líquido"
                                        disabled={!editable} />
                            </div>
                            <div className="col-12 col-md-3 fieldHolder millilitersHolder">
                                <TextField fullWidth
                                        id="milliliters"
                                        type="number"
                                        min="1"
                                        value={this.state.milliliters}
                                        onChange={this.handleFieldChange}
                                        label="Mililitros"
                                        placeholder="Mililitros"
                                        disabled={!editable} />
                            </div>
                            <div className="col-12 col-md-3 fieldHolder">
                                <TextField fullWidth
                                        id="quantity"
                                        type="number"
                                        min="1"
                                        value={this.state.quantity}
                                        onChange={this.handleFieldChange}
                                        label="Quantidade"
                                        placeholder="Quantidade"
                                        disabled={!editable} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-12 col-md-6 fieldHolder">
                                <TextField fullWidth
                                        id="internalRef"
                                        value={this.state.internalRef}
                                        onChange={this.handleFieldChange}
                                        label="Referência interna"
                                        placeholder="Introduza a Referência"
                                        disabled={!editable} />
                            </div>
                            <div className="col-12 col-md-6 fieldHolder">
                                <TextField fullWidth
                                        id="supplierRef"
                                        value={this.state.supplierRef}
                                        onChange={this.handleFieldChange}
                                        label="Referência fornecedor"
                                        placeholder="Introduza a Referência do fornecedor"
                                        disabled={!editable} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-12 col-md-8 fieldHolder">
                                <TextField fullWidth
                                        id="dimensions"
                                        min="1"
                                        value={this.state.dimensions}
                                        onChange={this.handleFieldChange}
                                        label="Dimensões"
                                        placeholder="Dimensões"
                                        disabled={!editable} />
                            </div>
                            <div className="col-12 col-md-4 fieldHolder">
                                <TextField fullWidth
                                        id="taxPercentage"
                                        type="number"
                                        min="1"
                                        value={this.state.taxPercentage}
                                        onChange={this.handleChangeTaxPercentage}
                                        label="% IVA"
                                        placeholder="Percentagem IVA"
                                        disabled={!editable} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth
                                id="barCode"
                                value={this.state.barCode}
                                onChange={this.handleFieldChange}
                                label="Código de Barras"
                                placeholder="Introduza o Código de Barras"
                                disabled={!editable} />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth
                                    id="description"
                                    value={this.state.description}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Descrição" />
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth
                                    id="ingredients"
                                    value={this.state.ingredients}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Ingredientes" />
                    </div>
                    <div className="col-12 smallMarginTop">
                        <FormControl className="alert" component="fieldset">
                            <FormLabel component="legend">Importante</FormLabel>
                            <div className="row">
                                <div className="col-12 col-md-6 fieldHolder noMarginTop">
                                    <TextField fullWidth
                                                id="importantInformation"
                                                value={this.state.importantInformation}
                                                onChange={this.handleFieldChange}
                                                disabled={!editable}
                                                multiline={true}
                                                rows={4}
                                                label="Informação Importante" />
                                </div>
                                <div className="col-12 col-md-6 fieldHolder noMarginTop">
                                    <TextField fullWidth
                                                id="alerts"
                                                value={this.state.alerts}
                                                onChange={this.handleFieldChange}
                                                disabled={!editable}
                                                multiline={true}
                                                rows={4}
                                                label="Alertas" />
                                </div>
                            </div>
                        </FormControl>               
                    </div>
                    <div className="col-12 col-md-6 fieldHolder">
                        <TextField fullWidth
                                    id="notes"
                                    value={this.state.notes}
                                    onChange={this.handleFieldChange}
                                    disabled={!editable}
                                    multiline={true}
                                    rows={4}
                                    label="Observações" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} className="defaultButton" variant="contained">Voltar</Button>
                        { (isAdmin || loginData.profile.Products.DEL) &&  this.state.productId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Produto</Button>}
                        { editable && <Button type="submit" className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </form>
        );
    }
}

export default AddEditProduct;
